<template>
  <div class="huayue">
    <div class="news-left">
      <div class="news-list-wrap">
        <div
          v-for="(item, index) in newsList"
          :key="index"
          class="news-item"
          @click="newsDetails(item)"
        >
          <div class="news-img">
            <img :src="item.icon" alt="" class="img" />
          </div>
          <div class="news-content">
            <div class="news-title">{{ item.title }}</div>
            <div class="news-describe">{{ item.description }}</div>
            <div class="news-time">{{ publishTime(item) }}</div>
          </div>
        </div>
      </div>
      <div class="news-pagination">
        <el-pagination
          background
          layout="prev, pager, next"
          :page-size="page.pageSize"
          :total="page.total"
          :hide-on-single-page="true"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
    <div class="news-right">
      <div class="hot-wrap">
        <div class="hot-tit">
          热门推荐
        </div>
        <div class="hot-news-list">
          <div
            v-for="(item, index) in hotNewsList"
            :key="index"
            class="hot-news-item"
            @click="newsDetails(item)"
          >
            <div class="news-time">{{ hotPublishTime(item) }}</div>
            <div class="news-title">{{ item.title }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { getContentList } from '@/api/content';
export default {
  name: 'HuayueInfoView',
  data() {
    return {
      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      newsList: [
        // {
        //   id: 5,
        //   title: '华跃科技祝贺顺德电子信息商会第四届理事会第十三次会议顺利举办！',
        //   describe: '11月17日下午，佛山市顺德区电子信息商会第四届理事会第十三次会议在顺德渔村华侨城会议厅顺利召开,华跃科技由研发部总经理黄桥先生代表出席本次会议。',
        //   time: '2022/11/21 17:26:00',
        //   img: require('@/assets/news/news1.png'),
        // },
        // {
        //   id: 6,
        //   title: '华跃科技党支部的红色印记',
        //   describe: '随着华跃科技的不断壮大，公司的社会担当也不可落下。大良街道文秀社区党委属下佛山市华跃计算机系统有限公司支部委员会成立至今，始终铭记自身的社会担当，全党...员上下齐心，主动作为，在疫情时刻主动担起社会责任，始终忠诚拥护“两个确立”，坚决做到“两个维护”，诠释了基层党员的使命和信念，书写了基层党支部的责任和担当。',
        //   time: '2022/11/21 17:26:00',
        //   img: require('@/assets/news/news2.png'),
        // },
      ],
      hotNewsList: [
        // {
        //   id: 0,
        //   title: '华跃科技员工专访第二期 ▏心有所向，乘风破浪',
        //   time: '11-04',
        // },
        // {
        //   id: 1,
        //   title: '凝心聚力创双优--行业500强企业对华跃的产品服给予高度认可与信任！',
        //   time: '10-21',
        // },
        // {
        //   id: 2,
        //   title: '华跃科技员工专访第二期 ▏心有所向，乘风破浪',
        //   time: '11-04',
        // },
        // {
        //   id: 3,
        //   title: '凝心聚力创双优--行业500强企业对华跃的产品服给予高度认可与信任！',
        //   time: '10-21',
        // },
        // {
        //   id: 4,
        //   title: '华跃科技员工专访第二期 ▏心有所向，乘风破浪',
        //   time: '11-04',
        // },
      ],
    };
  },
  mounted() {
    this.getnewsList();
    this.gethotNews();
  },
  methods: {
    async getnewsList() {
      var params = { columnId: '1605774350588534784', pageNum: this.page.pageNum, pageSize: this.page.pageSize, };
      var res = await getContentList(params);
      var { result, } = res;
      this.newsList = result.data;
      this.page.total = result.total;
    },

    async gethotNews() {
      var params = { columnId: '1605774350588534784', pageNum: 1, pageSize: 5, commendation: 7, };
      var res = await getContentList(params);
      var { result, } = res;
      this.hotNewsList = result.data;
    },

    publishTime(item) {
      return dayjs(item.publishTime).format('YYYY/MM/DD HH:mm:ss');
    },

    hotPublishTime(item) {
      return dayjs(item.publishTime).format('MM-DD');
    },

    handleCurrentChange(val) {
      this.page.pageNum = val;
      this.getnewsList();
    },

    newsDetails(item) {
      this.$router.push({ path: `/news/details/${item.id}`, query: { type: 1, }, });
    },
  },
};
</script>

<style lang="less" scoped>
.huayue{
    width: 1200px;
    margin: 0 auto;
    padding: 50px 0 90px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    .news-left{
        width: 770px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        .news-list-wrap{
            width: 100%;
            margin-bottom: 5px;
            .news-item{
                width: 100%;
                margin-bottom: 40px;
                display: flex;
                justify-content: flex-start;
                align-items: flex-start;
                cursor: pointer;
                .news-img{
                    width: 218px;
                    height: 130px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    overflow: hidden;
                    margin-right: 20px;
                    border-radius: 5px;
                    .img{
                        width: 100%;
                        height: auto;
                        display: block;
                    }
                }
                .news-content{
                    flex: 1;
                    padding-top: 6px;
                    box-sizing: border-box;
                    .news-title{
                        font-family: OPPOSans-M;
                        font-size: 18px;
                        color: #21252b;
                        line-height: 23px;
                        margin-bottom: 8px;
                    }
                    .news-describe{
                        font-family: OPPOSans-R;
                        font-size: 14px;
                        color: #5c6066;
                        line-height: 20px;
                        margin-bottom: 10px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        /* 将对象作为弹性伸缩盒子模型显示 */
                        display: -webkit-box;
                        /* 限制在一个块元素显示的文本的行数 */
                        /* -webkit-line-clamp 其实是一个不规范属性，使用了WebKit的CSS扩展属性，该方法适用于WebKit浏览器及移动端；*/
                        -webkit-line-clamp: 2;
                        /* 设置或检索伸缩盒对象的子元素的排列方式 */
                        -webkit-box-orient: vertical;
                    }
                    .news-time{
                        font-family: OPPOSans-R;
                        font-size: 12px;
                        color: #5c6066;
                    }
                }
            }
        }
        .news-pagination{
            ::v-deep .el-pagination{
                .btn-prev{
                    width: 32px;
                    height: 32px;
                    background-color: #f5f5f5;
                    border-radius: 4px;
                    border: 1px solid #dfdfdf;
                }
                .el-pager{
                    li{
                        width: 32px;
                        height: 32px;
                        background-color: #fff;
                        border-radius: 4px;
                        border: 1px solid #dfdfdf;
                    }
                    .active{
                        background-color: #00b0dc;
                    }
                }
                .btn-next{
                    width: 32px;
                    height: 32px;
                    background-color: #f5f5f5;
                    border-radius: 4px;
                    border: 1px solid #dfdfdf;
                }
            }
        }
    }
    .news-right{
        width: 380px;
        height: 300px;
        .hot-wrap{
            .hot-tit{
                width: 100%;
                padding-left: 10px;
                border-left: 4px solid #00b0dc;
                font-size: 20px;
                font-family: OPPOSans-R;
                color: #21252b;
                line-height: 22px;
                box-sizing: border-box;
            }
            .hot-news-list{
                width: 100%;
                margin-top: 20px;
                .hot-news-item{
                    width: 100%;
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    margin-bottom: 20px;
                    cursor: pointer;
                    .news-time{
                        flex: 1;
                        font-family: OPPOSans-R;
                        font-size: 12px;
                        color: #5c6066;
                        line-height: 1;
                    }
                    .news-title{
                        width: 313px;
                        font-family: OPPOSans-R;
                        font-size: 14px;
                        color: #21252b;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                }
            }
        }
    }
}
</style>
